export default function getSelectableTags(discussion) {
  let tags = app.store.all('tags');
  if (discussion) {
    const discussionTags = discussion.tags() || [];
    tags = tags.filter(tag => tag.canAddToDiscussion() || discussionTags.includes(tag));
  } else {
    tags = tags.filter(tag => tag.canStartDiscussion());
  }
  return tags;
}
flarum.reg.add('abdulrehman-tags', 'forum/utils/getSelectableTags', getSelectableTags);